<!-- Measurement probes: never shown, just used to read each candidate's natural width. Wrapped
     with prefix/suffix, same as the visible box below, so the measured width matches what actually
     gets rendered. The 0x0 clipped wrapper keeps those natural widths readable without letting them
     contribute to any ancestor's scrollable overflow (same guard as the availability sizer below) -
     a visibility:hidden absolute span still participates in layout and, per CSS Overflow 3 ,
     propagates its full natural width up through every visible-overflow ancestor. -->
<div aria-hidden="true" class="tw-invisible tw-absolute tw-h-0 tw-w-0 tw-overflow-hidden">
  <span #fullProbe class="tw-block tw-w-max" [class]="textClass()"
    >{{ prefix() }}{{ fullText() }}{{ suffix() }}</span
  >
  <span #fullNarrowProbe class="tw-block tw-w-max" [class]="textClass()"
    >{{ prefix() }}{{ effectiveFullTextNarrow() }}{{ suffix() }}</span
  >
  <span #compactProbe class="tw-block tw-w-max" [class]="textClass()"
    >{{ prefix() }}{{ compactText() }}{{ suffix() }}</span
  >
  <span #compactNarrowProbe class="tw-block tw-w-max" [class]="textClass()"
    >{{ prefix() }}{{ effectiveCompactTextNarrow() }}{{ suffix() }}</span
  >
</div>

<!-- Availability sizer: in normal flow (unlike the probes above) so it actually gets
     shrunk/stretched/clamped by the real surrounding layout, same as any other content would be.
     Always rendering fullText - the widest candidate - means its own clamped width reports the
     true available space regardless of which candidate is currently selected, so growing back to
     a wider candidate is detected exactly the same way as shrinking to a narrower one. Zero height
     keeps it from taking any visible vertical space. -->
<span
  #availabilitySizer
  class="tw-invisible tw-block tw-h-0 tw-overflow-hidden tw-whitespace-nowrap"
  [class]="textClass()"
  aria-hidden="true"
  >{{ prefix() }}{{ fullText() }}{{ suffix() }}</span
>

<!-- tw-align-top: an inline-block's default vertical-align is "baseline", which reserves extra
     room below it to line up with the surrounding text's baseline/descender - inflating the
     host's own auto-height beyond this box's real content height and throwing off vertical
     centering wherever a caller centers the host against a sibling (e.g. a label next to it). -->
<div
  class="tw-inline-block tw-align-top tw-overflow-x-auto tw-overflow-y-hidden tw-scroll-smooth hide-scrollbars tw-max-w-full"
  data-testid="large-amount-display"
>
  <span class="tw-whitespace-nowrap tw-inline-block" [class]="textClass()"
    >{{ prefix() }}{{ selectedText() }}{{ suffix() }}</span
  >
</div>
